import { render, staticRenderFns } from "./CreateReportForm.vue?vue&type=template&id=72f6572f"
import script from "./CreateReportForm.vue?vue&type=script&lang=js"
export * from "./CreateReportForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports